import { useEffect, useState } from 'react';
import '../style.scss';
import './style.scss';
import { ContentHeader } from 'views/components/molecules/contentHeader';
import {
  GetNotificationListQueryVariables,
  GetSymbolListQueryVariables,
  useGetNotificationListQuery,
} from 'views/utils/graphql/graphql';
import { useGetSymbolList } from '../productList/hooks/useGetSymbolList';
import { createListProductCard } from '../productList/function/createListProductCard';
import { List } from 'views/components/organisms/list';
import { getNoticeHeaderShowList } from 'views/constants/const/Notices';
import { BodyShowList } from 'views/components/molecules/listBody';
import { createBodyShowLists } from '../notice/function/createBodyShowList';
import { ModalBase, ModalStyle } from 'views/components/atoms/modal';
import { NoticeDetail } from '../noticeDetail';
import { NotificationDeliverTargetType } from 'views/constants/enums/Notice';
import { Loading } from 'views/components/atoms/loading';

const PAGE = 1;
const NOTICE_COUNT = 2;

const initialSymbolListVariables: GetSymbolListQueryVariables = {
  count: 1,
  page: PAGE,
};

export const Home = () => {
  const { getSymbolListState, showLoading } = useGetSymbolList(initialSymbolListVariables);

  // お知らせ　全体 / 個別
  const getNewNoticeAllListVariables = () => {
    const param: GetNotificationListQueryVariables = {
      count: NOTICE_COUNT,
      page: PAGE,
      deliveryTarget: NotificationDeliverTargetType.All,
    };
    return param;
  };

  const getNewNoticeListVariables = () => {
    const param: GetNotificationListQueryVariables = {
      count: NOTICE_COUNT,
      page: PAGE,
      deliveryTarget: NotificationDeliverTargetType.Personal,
    };
    return param;
  };

  const [noticeAllList, getNoticeAllList] = useGetNotificationListQuery({
    variables: getNewNoticeAllListVariables(),
    requestPolicy: 'network-only',
  });

  const [noticeList, getNoticeList] = useGetNotificationListQuery({
    variables: getNewNoticeListVariables(),
    requestPolicy: 'network-only',
  });

  // お知らせ全体の表示
  const [allBodyShowLists, setAllBodyShowLists] = useState<BodyShowList[]>([]);
  // お知らせ個別の表示
  const [bodyShowLists, setBodyShowLists] = useState<BodyShowList[]>([]);
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [noticeId, setNoticeId] = useState<string>('');

  useEffect(() => {
    if (!noticeList.data) return;
    const newBodyShowLists = createBodyShowLists(true, noticeList.data);
    setBodyShowLists(newBodyShowLists);
  }, [noticeList]);

  useEffect(() => {
    if (!noticeAllList.data) return;
    const newBodyShowLists = createBodyShowLists(false, noticeAllList.data);
    setAllBodyShowLists(newBodyShowLists);
  }, [noticeAllList]);

  return (
    <section className="outletWrapper">
      <div className="centerContent">
        <div className="centerContent_wrapper">
          <ContentHeader title={'新着銘柄'} />
          {showLoading && (
            <div className="loadingWrapper">
              <Loading />
            </div>
          )}
          {getSymbolListState.data && createListProductCard(getSymbolListState.data)}
        </div>
        <div className="centerContent_wrapper">
          <ContentHeader title={'全体へのお知らせ'} />
          <List
            headerShowList={getNoticeHeaderShowList(false)}
            bodyShowLists={allBodyShowLists}
            onClick={(index) => {
              if (!noticeAllList.data?.GetNotificationList?.Data) return;
              const data = noticeAllList.data.GetNotificationList.Data[index];
              setNoticeId(data?.ID || '');
              setIsOpenModal(true);
            }}
            loading={noticeAllList.fetching}
          />
        </div>
        <div className="centerContent_wrapper">
          <ContentHeader title={'あなたへのお知らせ'} />
          <List
            headerShowList={getNoticeHeaderShowList(true)}
            bodyShowLists={bodyShowLists}
            onClick={(index) => {
              if (!noticeList.data?.GetNotificationList?.Data) return;
              const data = noticeList.data.GetNotificationList.Data[index];
              setNoticeId(data?.ID || '');
              setIsOpenModal(true);
            }}
            loading={noticeList.fetching}
          />
        </div>
      </div>
      <ModalBase
        modalStyle={ModalStyle.confirmModal}
        isOpen={isOpenModal}
        onRequestClose={() => setIsOpenModal(false)}
        children={
          <NoticeDetail
            noticeId={noticeId}
            setIsOpenModal={setIsOpenModal}
            resetNoticeList={() => {
              getNoticeList(getNewNoticeListVariables());
              getNoticeAllList(getNewNoticeAllListVariables());
            }}
          />
        }
      />
    </section>
  );
};
